import { MessageBox, Button, message } from 'kenshin';
import TablePro from '@/components/TablePro';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'umi';
import { useMemoizedFn } from 'ahooks';
import {
  customerColumns,
  contractCloumns,
  projectCloumns,
  roleCloumns,
  getProjectSearchCloumns,
  getContractSearchCloumns,
  getCustomerSearchCloumns,
} from './columns';
import busiTypeKey from '../../_util/busiTypeKey';
import EllipsisTooltip from '@/components/EllipsisTooltip';
import { contractSubmit, customerSubmit, taskSubmit } from './onSubmit';
const { CUSTOMER, CONTRACT, PROJECT, TASK, ROLE, OSAEDIT, WEEKEDIT, VACATION } =
  busiTypeKey;
import Util from '../_unit';
const {
  TaskUtil,
  ContractUtil,
  CustomerUtil,
  ProjectUtil,
  RoleUtil,
  OsaEditUtil,

  AttendanceUtil,
} = Util;

const ChooseBusinessTable = ({
  busiType,
  visible,
  onCancel,
  process,
  onSave,
  onCreate,
}) => {
  const [selectKey, setSelectKey] = useState([]);
  const [taskTreeData, setTaskTreeData] = useState([]);
  const selectData = useRef();

  const tableRef = useRef();

  const dispatch = useDispatch();

  // Redux数据
  const customer = useSelector(({ customer }) => customer);
  const system = useSelector(({ system }) => system);
  const project = useSelector(({ project }) => project);
  const performance = useSelector(({ performance }) => performance);
  const contract = useSelector(({ contract }) => contract);
  const systemOrgani = useSelector(({ systemOrgani }) => systemOrgani);

  const attendance = useSelector(({ attendance }) => attendance);

  useEffect(() => {
    if (busiType == TASK) {
      // dispatch({
      //   type: 'systemOrgani/getAllEmployee',
      // });
      dispatch({
        type: 'project/getSimpProjectList',
      });
    }
  }, []);

  // 结构转换给树组件渲染
  const transformTreeData = useMemoizedFn((arr) => {
    return arr?.map((item) => {
      let children = null;
      if (item.childList) {
        children = transformTreeData(item.childList);
      }
      return {
        children,
        title: (
          <EllipsisTooltip
            value={`${item.servCatgCode} ${item.servCatgName}`}
            width={200 - 60}
            placement="right"
            trigger="click"
          />
        ),
        key: item.proServCatgId,
        ...item,
      };
    });
  });

  const projectSelectChange = (projectId) => {
    tableRef.current?.search?.setFieldsValue({ proServCatgId: undefined });
    if (!projectId) {
      setTaskTreeData([]);
      return;
    }
    dispatch({
      type: 'project/getProServcatgTree',
      payload: {
        projectId,
      },
    }).then((data) => {
      setTaskTreeData(transformTreeData(data));
    });
  };

  const delItem = (row) => {
    // MessageBox.confirm({
    //   title: '确认删除',
    //   content: '确定要删除这条数据吗？',
    //   onOk: () => {
    //     message.success('删除成功');
    //   },
    // });
    handleSave(row);
  };

  /**
   * 不同业务的表格属性
   * 1：客户管理；2：合同管理；3：项目管理；4：任务管理；5：角色管理；
   */
  const requestOrData = useMemo(() => {
    const addActionColumn = (columns) => {
      return [
        ...columns,
        {
          title: '操作',
          width: 150,
          fixed: 'right',
          key: 'options',
          render: (row) => {
            return (
              <>
                <Button type="text" onClick={() => delItem(row)}>
                  变更
                </Button>
              </>
            );
          },
        },
      ];
    };
    if (busiType == CUSTOMER) {
      //  客户
      return {
        searchCloumns: getCustomerSearchCloumns({ system }),
        request: 'customer/getCustomerList',
        data: customer.customerList,
        columns: addActionColumn(customerColumns(system)),
        rowKey: 'custId',
        key: 'customer',
      };
    }
    if (busiType == CONTRACT) {
      //  合同
      return {
        searchCloumns: ContractUtil.searchCloumns({ systemOrgani }),
        request: 'contract/getContractList',
        data: contract.contractList,
        columns: addActionColumn(contractCloumns(system)),
        rowKey: (row, index) => `${row.contractId}-${index}`,
        params: {
          roleList: JSON.parse(localStorage.getItem('employeeDTO'))?.roleList,
        },
        key: 'contract',
      };
    }
    if (busiType == PROJECT) {
      //  项目
      return {
        searchCloumns: getProjectSearchCloumns({ systemOrgani }),
        request: 'project/getProjectList',
        data: project.projectList,
        columns: addActionColumn(projectCloumns()),
        rowKey: 'projectId',
        params: {
          roleList: JSON.parse(localStorage.getItem('employeeDTO'))?.roleList,
        },
        key: 'project',
      };
    }
    if (busiType == TASK) {
      //  任务
      return {
        searchCloumns: TaskUtil.searchCloumns({
          userProjectSimpList: project.userProjectSimpList,
          employeeAll: systemOrgani.employeeAll,
          taskTreeData,
          projectSelectChange,
        }),
        request: 'project/getTaskPage',
        data: project.taskList,
        columns: addActionColumn(TaskUtil.cloumns()),
        rowKey: 'taskId',
        key: 'task',
      };
    }

    if (busiType == ROLE) {
      //  任务
      return {
        request: 'system/getroleList',
        data: system.roleList,
        columns: addActionColumn(roleCloumns()),
        rowKey: 'roleId',
        key: 'role',
      };
    }
    if (busiType == OSAEDIT) {
      const result = OsaEditUtil.tableOptions?.({
        performance,
        dispatch,
        type: OSAEDIT,
        tableRef: tableRef.current,
      });
      if (result && result.columns) {
        result.columns = addActionColumn(result.columns);
        result.key = 'osaaEdit';
      }
      // console.log('busiType1212121', busiType, result);
      return result;
    }
    if (busiType == WEEKEDIT) {
      const result = OsaEditUtil.tableOptions?.({
        performance,
        dispatch,
        type: WEEKEDIT,
        tableRef: tableRef.current,
      });
      if (result && result.columns) {
        result.columns = addActionColumn(result.columns);
        result.key = 'weekEdit';
      }
      // console.log('busiType1212121', busiType, result);
      return result;
    }
    if (busiType == VACATION) {
      const result = AttendanceUtil.tableOptions?.({
        // searchCloumns: [],
        attendance,
        dispatch,
        type: VACATION,
        tableRef: tableRef.current,
      });
      if (result && result.columns) {
        result.columns = addActionColumn(result.columns);
      }
      return result;
    }
  }, [
    busiType,
    customer,
    project,
    contract,
    system,
    systemOrgani,
    taskTreeData,
    performance,
    attendance,
  ]);

  // console.log('requestOrData...', requestOrData);

  // 点击保存的时候数据
  const handleSave = async (row) => {
    if (!row) {
      message.error('请选择业务！');
      return;
    }
    // onCancel();
    await onSave?.(row);
  };

  //  const handleSave = () => {
  //   if (!selectData.current) {
  //     message.error('请选择业务！');
  //     return;
  //   }
  //   // onCancel();
  //   onSave?.(selectData.current);
  // };

  const rowSelection = {
    selectedRowKeys: selectKey,
    onChange: (userIdList, row) => {
      selectData.current = row[row.length - 1];
      setSelectKey([userIdList[userIdList.length - 1]]);
    },
  };

  /** 搜索拦截 */
  const onSubmit = (val) => {
    if (busiType == TASK) {
      return taskSubmit(val, { employeeAll: systemOrgani.employeeAll });
    }
    if (busiType == CONTRACT) {
      return contractSubmit(val);
    }
    if (busiType == CUSTOMER) {
      return customerSubmit(val);
    }
    if (busiType == CUSTOMER) {
      return customerSubmit(val);
    }
  };

  return (
    // <MessageBox
    //   title="选择业务"
    //   onCancel={onCancel}
    //   width={1000}
    //   maskClosable={false}
    //   bodyStyle={{ maxHeight: 600, overflowY: 'auto' }}
    //   destroyOnClose
    //   visible={visible}
    //   footer={[
    //     <Button key="cancel" onClick={onCancel}>
    //       取消
    //     </Button>,
    //     <Button key="save" type="primary" onClick={handleSave}>
    //       确定
    //     </Button>,
    //   ]}
    // >

    <TablePro
      {...(requestOrData || { columns: [] })}
      curColumns
      onSubmit={onSubmit}
      columnsOptions={false}
      actionRef={(ref) => (tableRef.current = ref)}
      rowSelection={{
        type: 'checkbox',
        ...rowSelection,
      }}
    />

    // </MessageBox>
  );
};

export default ChooseBusinessTable;
